import React, { useEffect, useState } from 'react';
import { getRequest, postRequest } from '../../utils/requests';
import { API_ENDPOINT_URL, AUTH_PREFIX, APP_URL, APP_PREFIX } from '../../utils/appConstants';
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import {getStars, lowerCaseHyphenate} from '../../utils';
import Slider from 'react-slick';
import moment from 'moment';
import ikc from '../../assets/images/uk-kennel-club-logo.jpg';
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { Helmet } from 'react-helmet-async';
import {CURRENCY_SYMBOL} from "../../utils/appConstants";
import PuppyDepositInfoCard from "../../components/shared/PuppyDepositInfoCard";
import  {ReactComponent as MoneySymbolIcon}  from '../../assets/images/money-symbol.svg';

function SampleNextArrow(props) {
    const {className, style, onClick} = props;
    return (
        <a
            className={`${className} slickNext ssArrowViii text-center fontNoto text-uppercase position-absolute slick-arrow`}
            // style={{...style, display: 'block', color: 'black'}}
            onClick={onClick}
        >
            Next
            <i className="aricomoon-ararrowRight aricn"/>
        </a>
    );
}

function SamplePrevArrow(props) {
    const {className, style, onClick} = props;
    return (
        <a
            className={`${className} slickPrev ssArrowViii fontNoto text-center text-uppercase position-absolute slick-arrow`}
            // style={{...style, display: 'block', color: 'black'}}
            onClick={onClick}
        >
            <i className="aricomoon-ararrowLeft aricn"/>
            Previous
        </a>
    );
}

const ViewAdvert = () => {

    const [selectedAdvert, setSelectedAdvert] = useState(null);
    const [search, setSearch] = useSearchParams();
    const [clickSize, setClickSize] = useState(false);
    const [clickEnergy, setClickEnergy] = useState(false);
    const [clickTemprament, setClickTemprament] = useState(false);
    const [clickLife, setClickLife] = useState(false);
    const [clickGrooming, setClickGrooming] = useState(false);
    const [clickSpace, setClickSpace] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalErrors, setModalErrors] = useState(false);
    const [guestData, setGuestData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        pet_id: ''
    });
    const navigate = useNavigate();
    const params = useParams();
    const [isBuyer, setIsBuyer] = useState(true)
    const [isCharity, setIsCharity] = useState(false)
    const [hasPlacedDepositOnAdvert, setHasPlacedDepositOnAdvert] = useState(false)

    const settings = {
        dots: true,
        arrows: true,
        appendDots: dots => (
            <div>
                <ul className="arsliderCountList d-flex justify-content-center justify-content-md-start align-items-center list-unstyled mb-0"> {dots} </ul>
            </div>
        ),
        nextArrow: <SampleNextArrow/>,
        prevArrow: <SamplePrevArrow/>,
        speed: 500,
        autoplay: false,
        fade: true,
        autoplaySpeed: 4000,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
    };

    useEffect(() => {
        const isUserLoggedIn = !!localStorage.getItem('access_token');
        if (isUserLoggedIn) {
            const userRole = JSON.parse(localStorage.getItem("currentUser"))?.role;

            if (userRole !== 'buyer') {
                setIsBuyer(false);
            }
        }
        const id = search.get('id');
        getRequest(`${API_ENDPOINT_URL}/f-end/advert/view/${params?.breed}/${params?.advertName}/${id}`).then((res) => {
            if (res) {

                setSelectedAdvert(res.data.data);
                setIsCharity(res.data.data.user?.role === 'charity');
                handleHasPlacedDepositOnAdvert(res.data.data);
            } else {
                navigate(`/pet-listing/${params?.breed}`);
            }
        });
    }, []);

    const getDates = () => {
        const current = moment().format('YYYY-MM-DD');
        const advertDate = moment(selectedAdvert?.dob, 'YYYY-MM-DD');
        const advertDate2 = moment(selectedAdvert?.dob, 'YYYY-MM-DD').format('DD-MM-YYYY');
        const days = moment.duration(moment(current).diff(advertDate)).asDays();
        const fiftySixDays = moment(advertDate).add(56, 'd').format('YYYY-MM-DD');
        const rehome = Number(moment.duration(moment(fiftySixDays).diff(current)).asDays().toFixed(1));
        if (days >= 0 && rehome >= 0) {
            if (rehome > 0) {
                return (
                    <>
                        <span
                            className="aricnWrap flex-shrink-0 d-flex align-items-center justify-content-center rounded-sm bg-info text-white"><i
                            className="aricomoon-arcaledar"><span className="sr-only">icon</span></i></span>
                        <strong className="d-block font-weight-normal"><p>{days} days old : {rehome} days left to
                            rehome</p></strong>
                    </>
                );
            } else {
                return (
                    <>
                        <span
                            className="aricnWrap flex-shrink-0 d-flex align-items-center justify-content-center rounded-sm bg-info text-white"> <i
                            className="aricomoon-arcaledar"><span className="sr-only">icon</span></i></span>
                        <strong className="d-block font-weight-normal"><p>{advertDate2}</p></strong>
                    </>
                );
            }
            ;
        }
    };

    const currentUserId = JSON.parse(
        localStorage.getItem("currentUser")
    )?.id;

    const handleHasPlacedDepositOnAdvert = (advert) => {
        let hasPlacedDeposit = false;
        advert?.pets.forEach((pet) => {
            if(hasPlacedDepositOnPet(pet)) {
                hasPlacedDeposit = true;
            }
        })

        setHasPlacedDepositOnAdvert(hasPlacedDeposit)
    }

    const hasPlacedDepositOnPet = (pet) => {
        if(!pet.order || !currentUserId) {
            return false;
        }

        return pet.order.user_id === currentUserId && pet.order.type === 'deposit';
    }

    const meetPuppyLink = (pet) => {
        return `/pet-listing/${lowerCaseHyphenate(selectedAdvert.name)}/${lowerCaseHyphenate(selectedAdvert.advert_name)}/${lowerCaseHyphenate(pet.name)}/visit?id=${pet.id}`
    }

    const handlePayments = (isDeposit, petId) => {
        const isAuthenticated = localStorage.getItem('access_token');
        if (isAuthenticated) {
            const body = {pet_id: petId, is_deposit: isDeposit};
            postRequest(`${API_ENDPOINT_URL}/buyer/checkout`, body, true).then((res) => {
                if (res) {
                    window.location.href = res.data.data.url;
                }
            });
        } else {
            navigate(`${AUTH_PREFIX}/buyer-signup`);
        }
    };

    const handleChatNow = () => {
        const isAuthenticated = localStorage.getItem('access_token');
        if (isAuthenticated) {
            const advertId = search.get('id');
            postRequest(`${API_ENDPOINT_URL}/buyer/messages/${advertId}/create`, {}, true).then((res) => {
                if (res) {
                    navigate(`${APP_PREFIX}/messages/view-chat/${res.data.data.chat_id}`);
                }
            });
        } else {
            navigate(`${AUTH_PREFIX}/login?redirectToChat=${encodeURIComponent(window.location.href)}`);
        }
    };

    const validateModal = () => {
        let errors = {};
        let isValid = true;

        if (!guestData.first_name) {
            isValid = false;
            errors['first_name'] = 'This field is required';
        }
        if (!guestData.last_name) {
            isValid = false;
            errors['last_name'] = 'This field is required';
        }
        if (!guestData.email) {
            isValid = false;
            errors['email'] = 'This field is required';
        }
        setModalErrors(errors);
        return isValid;
    };

    const handleGuestCheckout = (event) => {
        event.preventDefault();
        if (validateModal()) {
            postRequest(`${API_ENDPOINT_URL}/guest/checkout`, guestData).then((res) => {
                if (res) {
                    window.location.href = res.data.data.url;
                }
            });
        }
    };

    return (
        <>
            <Helmet>
                <title>{`${selectedAdvert?.advert_name}`} | for Sale | PetBond</title>
                <meta name="description" content={`${selectedAdvert?.description}`}/>
                <meta name="robots" content="noindex"/>
            </Helmet>
            <header className="arbannerHeader position-relative overflow-hidden w-100 mb-5 mg-md-10 mb-lg-15">
                <div className="container">
                    <div className="arextraWrap">
                        <h1 className="text-capitalize">{selectedAdvert?.advert_name}</h1>
                    </div>
                    <div className="arbhImgHolder d-none d-md-block position-absolute">
                        <img src="/images/img07.png" className="img-fluid" alt="petbond"/>
                    </div>
                </div>
                <span className="arabPetIcn arabPetIcnvix position-absolute d-none d-md-block">
							<i className="aricomoon-hearts"><span className="sr-only">icon</span></i>
						</span>
                <span className="arabPetIcn arabPetIcnx position-absolute d-md-none">
							<i className="aricomoon-starDots"><span className="sr-only">icon</span></i>
						</span>
            </header>

            { !isCharity && !hasPlacedDepositOnAdvert && (
                <div className="container">
                    <PuppyDepositInfoCard light />
                </div>
            )}

            <div className="container pt-5 pb-10 pb-md-15 pb-lg-20 petDetailWrap">
                <article className="arptBoxWrap arptBoxWrapvii shadow rounded bg-white">
                    { hasPlacedDepositOnAdvert && (
                    <div className="container rounded deposit-success mb-6 mb-md-14">
                        <div className="row">
                            <div className="col-md-7">
                                <h3 className="deposit-success__heading fontFredoka">
                                    Your deposit was submitted successfully!
                                </h3>
                                <p className="deposit-success__p">You are one step closer to taking them home. Let’s start a conversation with the breeder.</p>
                            </div>
                            <div className="col-md-5 d-flex align-items-center">
                                <button type="button"
                                        onClick={() => handleChatNow()}
                                        className="deposit-success__btn btn bg-warning d-block px-lg-8 text-white font-weight-bold">
                                    Chat with the Breeder
                                </button>
                            </div>
                        </div>
                    </div>
                    )}
                    <header
                        className={`arptinfoHeadingHead position-relative p-0 ${selectedAdvert?.user?.kenney_club && 'arptkcImageActive'}`}>
                        <Slider className="arppsImagesSlider" {...settings}>
                            {
                                selectedAdvert?.pets?.map((pet, i) => (
                                    <div key={i}>
                                        <div className={"arppsisMaxterWrap" + (isBuyer ? ' isBuyerActive' : '')}>
                                            <h1>Name: {pet?.name}</h1>
                                            <div className='arptihhBtnWrap'>
                                                <div className="arptihhPriceBox text-right text-md-center">
                                                    <h2 className="fontNoto font-weight-bold mb-0">
                                                        {CURRENCY_SYMBOL}{
                                                        Number.isSafeInteger(pet?.price) ? pet?.price : pet?.price?.toFixed(2)
                                                    }
                                                    </h2>
                                                </div>
                                                <ul className="list-unstyled arptihhBtnsList">
                                                    {hasPlacedDepositOnAdvert && (
                                                        <li>
                                                            <div className="d-md-block w-md-100 text-primary font-weight-bold deposit-made-badge">
                                                                <span className="pr-2"><MoneySymbolIcon/></span>
                                                                <span>Deposit Made</span>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {!isCharity && (
                                                        <li>
                                                            <button type="button"
                                                                    onClick={() => handlePayments(0, pet?.pet_id)}
                                                                    className="btn bg-info text-uppercase d-block w-100 text-primary font-weight-bold">
                                                                PAY NOW {CURRENCY_SYMBOL}
                                                            </button>
                                                        </li>
                                                    )}
                                                    {!isCharity && !hasPlacedDepositOnAdvert && (
                                                            <li>
                                                                <Link
                                                                    to={meetPuppyLink(pet)}
                                                                    className="btn bg-warning text-uppercase d-block w-100 text-white font-weight-bold">
                                                                    Meet the puppy
                                                                </Link>
                                                            </li>
                                                    )}
                                                    {isBuyer && isCharity && (
                                                        <li>
                                                            <button type="button"
                                                                    onClick={() => handleChatNow()}
                                                               className="btn bg-primary text-uppercase w-100 text-white font-weight-bold">Chat Now</button>
                                                        </li>
                                                    )}
                                                </ul>
                                                {selectedAdvert?.user?.kenney_club != 'null' && selectedAdvert?.user?.kenney_club?.replace(/\s+/g, '') != '' && selectedAdvert?.user?.kenney_club != null &&
                                                    <div className="sdkkcImageWrap">
                                                        <strong className="d-block sdkcTitle text-center">Kennel
                                                            Club Registered</strong>
                                                        <img src={ikc} className="img-fluid" alt="dogtrust"/>
                                                    </div>
                                                }
                                            </div>
                                            <p>{i + 1} of a litter of {selectedAdvert?.pets?.length} from a beautiful
                                                mother and father.</p>
                                            <p>{selectedAdvert?.description}</p>
                                            <ul className="list-unstyled d-flex align-items-center mb-0 arptinfoCharList text-primary flex-wrap">
                                                <li>
                                                    <span
                                                        className="aricnWrap flex-shrink-0 d-flex align-items-center justify-content-center rounded-sm bg-info text-white">
                                                        <i className="aricomoon-arclaw"><span
                                                            className="sr-only">icon</span></i>
                                                    </span>
                                                    <strong
                                                        className="d-block font-weight-normal">Breed: {selectedAdvert?.name}</strong>
                                                </li>
                                                <li>{getDates()}</li>
                                            </ul>
                                            <div className="arppsExtraWrap">
                                                <div className="row">
                                                    <div
                                                        className={`col-12 ${selectedAdvert?.user?.kenney_club ? 'col-lg-6' : 'col-md-6'}`}>
                                                        <div className="arppsisImage">
                                                            <div>
                                                                <div
                                                                    className="rounded-sm overflow-hidden position-relative arppisImageColumn">
                                                                    <img
                                                                        src={pet?.photo ? `${API_ENDPOINT_URL}/image-retrieve/${pet?.photo}` : '/images/image-placeholder.png'}
                                                                        alt="img"
                                                                        className="img-fluid w-100 h-100 arppsicImgFull position-absolute"
                                                                    />
                                                                    <a href="#"
                                                                       className="arppsisZoomLink position-absolute">
                                                                        <i className="aricomoon-arzoom"><span
                                                                            className="sr-only">icon</span></i>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className={`col-12 ${selectedAdvert?.user?.kenney_club ? 'col-lg-6' : 'col-md-6'}`}>
                                                        <ul className="list-unstyled arppsInfosList">
                                                            {
                                                                pet?.gender &&
                                                                <li>
                                                                    <strong
                                                                        className="d-block flex-shrink-0 artitle font-weight-normal">Sex:</strong>
                                                                    <strong
                                                                        className="d-block flex-grow-1 arsubTitle font-weight-normal text-capitalize">
                                                                        {pet?.gender}
                                                                    </strong>
                                                                </li>
                                                            }
                                                            {
                                                                selectedAdvert?.user?.city?.name &&
                                                                <li>
                                                                    <strong
                                                                        className="d-block flex-shrink-0 artitle font-weight-normal">Location:</strong>
                                                                    <strong
                                                                        className="d-block flex-grow-1 arsubTitle font-weight-normal text-capitalize">
                                                                        {selectedAdvert?.user?.city?.name}
                                                                    </strong>
                                                                </li>
                                                            }
                                                            {
                                                                pet?.color &&
                                                                <li>
                                                                    <strong
                                                                        className="d-block flex-shrink-0 artitle font-weight-normal">Colour:</strong>
                                                                    <strong
                                                                        className="d-block flex-grow-1 arsubTitle font-weight-normal text-capitalize">
                                                                        {pet?.color}
                                                                    </strong>
                                                                </li>
                                                            }
                                                            {
                                                                selectedAdvert?.pets?.length &&
                                                                <li>
                                                                    <strong
                                                                        className="d-block flex-shrink-0 artitle font-weight-normal">
                                                                        From a litter of:</strong>
                                                                    <strong
                                                                        className="d-block flex-grow-1 arsubTitle font-weight-normal text-capitalize">
                                                                        {selectedAdvert?.pets?.length}
                                                                    </strong>
                                                                </li>
                                                            }
                                                            {
                                                                selectedAdvert?.mother_name &&
                                                                <li>
                                                                    <strong
                                                                        className="d-block flex-shrink-0 artitle font-weight-normal">Mother:</strong>
                                                                    <strong
                                                                        className="d-block flex-grow-1 arsubTitle font-weight-normal text-capitalize">
                                                                        {selectedAdvert?.mother_name}
                                                                    </strong>
                                                                </li>
                                                            }
                                                            {
                                                                selectedAdvert?.father_name &&
                                                                <li>
                                                                    <strong
                                                                        className="d-block flex-shrink-0 artitle font-weight-normal">Father:</strong>
                                                                    <strong
                                                                        className="d-block flex-grow-1 arsubTitle font-weight-normal text-capitalize">
                                                                        {selectedAdvert?.father_name}
                                                                    </strong>
                                                                </li>
                                                            }
                                                            {
                                                                (pet?.chip_number && !pet?.chip_number?.includes('pet_bond_chip')) &&
                                                                <li>
                                                                    <strong
                                                                        className="d-block flex-shrink-0 artitle font-weight-normal">Microchip
                                                                        No:</strong>
                                                                    <strong
                                                                        className="d-block flex-grow-1 arsubTitle font-weight-normal text-capitalize">
                                                                        {pet?.chip_number}
                                                                    </strong>
                                                                </li>
                                                            }
                                                            {
                                                                selectedAdvert?.user?.reg_number &&
                                                                <li>
                                                                    <strong
                                                                        className="d-block flex-shrink-0 artitle font-weight-normal">Licence Number:</strong>
                                                                    <strong
                                                                        className="d-block flex-grow-1 arsubTitle font-weight-normal text-capitalize">
                                                                        {selectedAdvert?.user?.reg_number}
                                                                    </strong>
                                                                </li>
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </Slider>
                    </header>
                    <div className="arppscsColumnsWrap aprpccHasMargin">
                        <div className="arppscwCol">
                            <div className="arppsheadingBdrWrap">
                                <h3 className="font-weight-normal fontBase">Breed Characteristics</h3>
                            </div>
                            <div className="rounded-sm arppsbcCharBox overflow-hidden">
                                <ul className="list-unstyled arppsbccbCharList">
                                    <li
                                        className={clickSize ? 'arppsbccbChrActive' : ''}
                                    >
                                        <div className="d-flex align-items-center">
                                            <strong className="font-weight-normal d-block artitle flex-shrink-0">
                                                Size&hellip;
                                            </strong>
                                            <button
                                                className="arppsbccbCharOpener position-absolute rounded-circle d-md-flex align-items-center justify-content-center"
                                                onClick={() => {
                                                    setClickSize(!clickSize);
                                                }}
                                            >
                                            </button>
                                            <ul className="gradList list-unstyled d-flex mb-0">
                                                {
                                                    getStars(selectedAdvert?.size).map((star, i) => (
                                                        <li className={star ? 'active' : ''}
                                                            key={i}/>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                        <div className="arppsbssChrDescrWrap text-primary">
                                            <p>{selectedAdvert?.size_desc}</p>
                                        </div>
                                    </li>
                                    <li
                                        className={clickEnergy ? 'arppsbccbChrActive' : ''}
                                    >
                                        <div className="d-flex align-items-center">
                                            <strong className="font-weight-normal d-block artitle flex-shrink-0">
                                                Energy&hellip;
                                            </strong>
                                            <button
                                                className="arppsbccbCharOpener position-absolute rounded-circle d-md-flex align-items-center justify-content-center"
                                                onClick={() => {
                                                    setClickEnergy(!clickEnergy);
                                                }}
                                            >
                                            </button>
                                            <ul className="gradList list-unstyled d-flex mb-0">
                                                {
                                                    getStars(selectedAdvert?.energy).map((star, i) => (
                                                        <li className={star ? 'active' : ''}
                                                            key={i}/>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                        <div className="arppsbssChrDescrWrap text-primary">
                                            <p>{selectedAdvert?.energy_desc}</p>
                                        </div>
                                    </li>
                                    <li
                                        className={clickTemprament ? 'arppsbccbChrActive' : ''}
                                    >
                                        {/* <div className="d-flex align-items-center">
                                            <strong className="font-weight-normal d-block artitle flex-shrink-0">
                                                Temperament&hellip;
                                            </strong>
                                            <button
                                                className="arppsbccbCharOpener position-absolute rounded-circle d-md-flex align-items-center justify-content-center"
                                                onClick={() => {
                                                    setClickTemprament(!clickTemprament);
                                                }}
                                            >
                                            </button>
                                            <ul className="gradList list-unstyled d-flex mb-0">
                                                {
                                                    getStars(selectedAdvert?.temperament).map((star, i) => (
                                                        <li className={star ? 'active' : ''}
                                                            key={i}/>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                        <div className="arppsbssChrDescrWrap text-primary">
                                            <p>Suitable for small to medium apartments and houses</p>
                                        </div> */}
                                    </li>
                                    <li
                                        className={clickLife ? 'arppsbccbChrActive' : ''}
                                    >
                                        <div className="d-flex align-items-center">
                                            <strong className="font-weight-normal d-block artitle flex-shrink-0">
                                                Lifespan&hellip;
                                            </strong>
                                            <button
                                                className="arppsbccbCharOpener position-absolute rounded-circle d-md-flex align-items-center justify-content-center"
                                                onClick={() => {
                                                    setClickLife(!clickLife);
                                                }}
                                            >
                                            </button>
                                            <ul className="gradList list-unstyled d-flex mb-0">
                                                {
                                                    getStars(selectedAdvert?.life_span).map((star, i) => (
                                                        <li className={star ? 'active' : ''}
                                                            key={i}/>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                        <div className="arppsbssChrDescrWrap text-primary">
                                            <p>{selectedAdvert?.life_span_desc}</p>
                                        </div>
                                    </li>
                                    <li
                                        className={clickGrooming ? 'arppsbccbChrActive' : ''}
                                    >
                                        <div className="d-flex align-items-center">
                                            <strong className="font-weight-normal d-block artitle flex-shrink-0">
                                                Grooming&hellip;
                                            </strong>
                                            <button
                                                className="arppsbccbCharOpener position-absolute rounded-circle d-md-flex align-items-center justify-content-center"
                                                onClick={() => {
                                                    setClickGrooming(!clickGrooming);
                                                }}
                                            >
                                            </button>
                                            <ul className="gradList list-unstyled d-flex mb-0">
                                                {
                                                    getStars(selectedAdvert?.grooming).map((star, i) => (
                                                        <li className={star ? 'active' : ''}
                                                            key={i}/>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                        <div className="arppsbssChrDescrWrap text-primary">
                                            <p>{selectedAdvert?.grooming_desc}</p>
                                        </div>
                                    </li>
                                    <li
                                        className={clickSpace ? 'arppsbccbChrActive' : ''}
                                    >
                                        <div className="d-flex align-items-center">
                                            <strong className="font-weight-normal d-block artitle flex-shrink-0">
                                                Living Space&hellip;
                                            </strong>
                                            <button
                                                className="arppsbccbCharOpener position-absolute rounded-circle d-md-flex align-items-center justify-content-center"
                                                onClick={() => {
                                                    setClickSpace(!clickSpace);
                                                }}
                                            >
                                            </button>
                                            <ul className="gradList list-unstyled d-flex mb-0">
                                                {
                                                    getStars(selectedAdvert?.living_space).map((star, i) => (
                                                        <li className={star ? 'active' : ''}
                                                            key={i}/>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                        <div className="arppsbssChrDescrWrap text-primary">
                                            <p>{selectedAdvert?.living_space_desc}</p>
                                        </div>
                                    </li>
                                </ul>
                                <div className="arppsbssChrDescrWrap text-primary">
                                    <p>Suitable for small to medium apartments and houses</p>
                                </div>
                            </div>
                        </div>
                        <div className="arppscwCol">
                            <div className="arppsheadingBdrWrap">
                                <h3 className="font-weight-normal fontBase">
                                    {
                                        selectedAdvert?.pets[0]?.pet_verified_by &&
                                        <span>Petbond Health Check</span>
                                    }
                                </h3>
                            </div>
                            <div className="w-100">
                                <ul className="list-unstyled arphcInfosList d-flex flex-wrap">
                                    {
                                        selectedAdvert?.mother_examinations?.map((exam) => (
                                            <li key={exam.id}>
                                                <span
                                                    className="flex-shrink-0 aricnWrap text-center d-flex align-items-center justify-content-center rounded-sm bg-success">
                                                    <span className="w-100 d-block">
                                                        <img src={exam?.icon ? exam?.icon : '/images/ardevicn01.svg'}
                                                             className="img-fluid"
                                                             width="24"
                                                             height="29" alt="icon"/>
                                                    </span>
                                                </span>
                                                <h4 className="font-weight-normal fontBase mb-0 text-capitalize">
                                                    {exam?.name}
                                                </h4>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                            {
                                selectedAdvert?.pets[0]?.pet_verified_by &&
                                <div className="text-primary arpsttpTextSmall">
                                    <p>This health check was performed by a Petbond Recommended Veterinarian
                                        practice: <strong>{selectedAdvert?.pets[0]?.pet_verified_by}</strong></p>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="aprpccHasMargin position-relative">
                        <div className="arppsheadingBdrWrap">
                            <h3 className="font-weight-normal fontBase">Breeder information</h3>
                        </div>
                        <ul className="list-unstyled d-flex flex-wrap arpbiiFeatList">
                            {selectedAdvert?.user?.kenney_club &&
                                <li>
                                    <span
                                        className="aricnWrap d-flex align-items-center justify-content-center rounded-circle text-center flex-shrink-0">
                                        <span className="d-block w-100">
                                            <img src="/images/ardevicn10.svg" className="img-fluid" width="17"
                                                 height="17"
                                                 alt="icon"/>
                                        </span>
                                    </span>
                                    <h4 className="font-weight-normal fontBase mb-0">Kennel Club Registered</h4>
                                </li>
                            }
                            {
                                selectedAdvert?.pets[0]?.pet_verified_by &&
                                <li>
								<span
                                    className="aricnWrap d-flex align-items-center justify-content-center rounded-circle text-center flex-shrink-0">
									<span className="d-block w-100">
										<img src="/images/ardevicn12.png" className="img-fluid" width="17" height="17"
                                             alt="icon"/>
									</span>
								</span>
                                    <h4 className="font-weight-normal fontBase mb-0">Vet Approved Breeder</h4>
                                </li>
                            }
                            <li>
								<span
                                    className="aricnWrap d-flex align-items-center justify-content-center rounded-circle text-center flex-shrink-0">
									<span className="d-block w-100">
										<img src="/images/ardevicn11.svg" className="img-fluid" width="17" height="17"
                                             alt="icon"/>
									</span>
								</span>
                                <h4 className="font-weight-normal fontBase mb-0">PetBond Approved Breeder</h4>
                            </li>
                        </ul>
                        <div className="arpjdescrWrap d-md-flex align-items-md-center">
							<span
                                className="arpjProfilerWrap flex-shrink-0 rounded-sm overflow-hidden d-flex align-items-center justify-content-center text-center bg-light2">
								<span className="d-block w-100">
									<img
                                        src={selectedAdvert?.user?.avatar ? `${API_ENDPOINT_URL}/image-retrieve/${selectedAdvert?.user?.avatar}` : '/images/prjPlaceIcn.svg'}
                                        className="img-fluid" width="76" height="76"
                                        alt="img description"/>
								</span>
							</span>
                            <p>{selectedAdvert?.user?.bio}</p>
                        </div>
                    </div>
                </article>
                <article className="um-nhcBannerWrap rounded shadow my-10">
                    <div className="textWrapper">
                        <h3 className="d-block">Need Help Choosing<br/> your most suited<br/> puppy?.</h3>
                        <div className="um-formBtnWrap">
                            <Link to={`/petbond-match`} className="btn btnFormWidth btn-primary btnFormStyle">Try My
                                PetBond
                                Match <svg xmlns="http://www.w3.org/2000/svg" width="46.391" height="21.679"
                                           viewBox="0 0 46.391 21.679">
                                    <g id="Group_1261" data-name="Group 1261"
                                       transform="translate(-2124.459 -1777.516)">
                                        <g id="Group_1260" data-name="Group 1260">
                                            <path id="Path_83004" data-name="Path 83004"
                                                  d="M2166.894,1794.56a9.025,9.025,0,0,0,3.956-7.228c0-5.421-5.421-9.816-12.158-9.816a13.239,13.239,0,0,0-9.62,3.857,10.622,10.622,0,0,1,1.856,5.957,10.411,10.411,0,0,1-1.9,5.957,13.225,13.225,0,0,0,9.619,3.857,15.134,15.134,0,0,0,2.1-.147,15.951,15.951,0,0,0,6.154,2.2h.1a1.526,1.526,0,0,0,.88-.439c.538-.732.1-1.465-.294-2.051a3.263,3.263,0,0,1-.687-2.145Zm-3.075-8.74-4.883,4.883a1,1,0,0,1-.733.294.983.983,0,0,1-.732-.294l-2.785-2.832a1.036,1.036,0,0,1,1.465-1.465l2.05,2.05,4.151-4.151a1.061,1.061,0,0,1,1.465,0,1.127,1.127,0,0,1,0,1.515Z"
                                                  fill="#fff"/>
                                            <path id="Path_83005" data-name="Path 83005"
                                                  d="M2136.57,1777.519c-6.689,0-12.111,4.394-12.111,9.816a9.088,9.088,0,0,0,3.957,7.228,3.444,3.444,0,0,1-.733,2.1c-.391.585-.83,1.367-.294,2.05a1.277,1.277,0,0,0,.88.439h.1a15.7,15.7,0,0,0,6.154-2.2,15.253,15.253,0,0,0,2.1.146c6.69,0,12.158-4.394,12.158-9.816s-5.468-9.766-12.208-9.766Zm.195,15.576a1.123,1.123,0,1,1,1.124-1.123A1.136,1.136,0,0,1,2136.765,1793.095Zm2.783-6.152a4.424,4.424,0,0,1-1.27,1.171,1.14,1.14,0,0,0-.636,1.074.481.481,0,0,1-.488.439h-.879a.445.445,0,0,1-.342-.147.529.529,0,0,1-.147-.341,2.8,2.8,0,0,1,1.416-2.492,2.469,2.469,0,0,0,.83-.782,1.337,1.337,0,0,0,.1-1.415,1.862,1.862,0,0,0-3.369.635.476.476,0,0,1-.488.391l-.778,0a.378.378,0,0,1-.342-.147.556.556,0,0,1-.147-.391,3.648,3.648,0,0,1,6.787-1.268,2.951,2.951,0,0,1-.244,3.271Z"
                                                  fill="#fff"/>
                                        </g>
                                    </g>
                                </svg>
                            </Link>
                        </div>
                    </div>
                    <div className="nhcImgHolder inaccessiable">
                        <img src="/images/imgdev3.png" alt="image decription"/>
                    </div>
                    <div className="nhcThinkQuote">
                        <strong className="d-block">You'de be<br/> barking mad<br/> not to try!</strong>
                        <span className="d-block cloudIcn">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="279.338" height="221.472"
                                         viewBox="0 0 279.338 221.472"><path id="Path_83003" data-name="Path 83003"
                                                                             d="M2368.755,1579a5.93,5.93,0,0,1-4.485-.425,9.772,9.772,0,0,1-4.234-4.768c-.535-1.841-1.494-3.557-2.014-5.4l.016-.015a50.092,50.092,0,0,1-.913-5.492,12.153,12.153,0,0,0-2-.441,36.807,36.807,0,0,0-10.748.928,7.388,7.388,0,0,0-2.377.834,21.053,21.053,0,0,1-5.633,2.361,20.973,20.973,0,0,0-4.878,2.3c-2.03,1.291-3.887,2.864-5.823,4.3h.016a14.574,14.574,0,0,0-3.194,3.4,40.878,40.878,0,0,1-4.737,5.43,9.849,9.849,0,0,0-2.864,5.681,118.381,118.381,0,0,0-1.181,12.919,13.972,13.972,0,0,0,.96,5.256,57.914,57.914,0,0,1,2.093,8.75,9.273,9.273,0,0,1-.8,5.555,11.909,11.909,0,0,1-1.952-.268,15.608,15.608,0,0,1-5.7-3.666,7.913,7.913,0,0,1-1.794-3.431c-1.007-3.084-1.857-6.232-2.8-9.347a1.8,1.8,0,0,0-2.077-1.558v-.016a4.036,4.036,0,0,0-1.433.205,63.985,63.985,0,0,0-10.7,4.264,10.2,10.2,0,0,0-3.368,3.085,71.009,71.009,0,0,1-6.09,7.616,13.4,13.4,0,0,0-3.241,5.555,4.286,4.286,0,0,1-.661,1.668,37.649,37.649,0,0,0-4.706,14.635,2.82,2.82,0,0,0-.031,1.086,36.2,36.2,0,0,0,5.854,16.523c1.479,2.046,2.8,4.233,4.406,6.169h-.016a21.2,21.2,0,0,0,7.727,5.838,36,36,0,0,0,9.725,3.839,4.51,4.51,0,0,1,1.338.536,90.094,90.094,0,0,1,11.96,6.294c-.063.645.11,1.495-.236,1.983h.016a6.6,6.6,0,0,0-1.527,6.672,33.438,33.438,0,0,1-8.781,1.747,6.581,6.581,0,0,1-3.4-.992,118.671,118.671,0,0,1-17.231-10.622l-.9-.582a1.246,1.246,0,0,0-1.055-.094,1.274,1.274,0,0,0-.708.771,35.4,35.4,0,0,0-2.423,15.595,16.546,16.546,0,0,0,1.054,4.17,27.726,27.726,0,0,0,1.668,3.6,4.215,4.215,0,0,0,1.228,1.731,11.182,11.182,0,0,1,4,5.02,28.746,28.746,0,0,0,8.639,9.505,23.632,23.632,0,0,0,11.031,4.28,53.311,53.311,0,0,0,10.355,1.479,36.266,36.266,0,0,0,12.054-2.046c1.9-.739,3.9-1.227,5.838-1.888,1.369-.472,2.676-1.086,4.045-1.574a26.922,26.922,0,0,1,4.783-1.542,42.741,42.741,0,0,1,13.2-.173,3.342,3.342,0,0,1,1.117,3.368,2.906,2.906,0,0,0,1.968,3.446,96.979,96.979,0,0,1,9.693,5.571c1.039.613,2.124,1.148,3.132,1.809v-.015a24.341,24.341,0,0,0,7.522,3.446,66.37,66.37,0,0,0,15.956,3.037,37.561,37.561,0,0,0,6.09.268,81.359,81.359,0,0,0,26.375-8.5,42.415,42.415,0,0,0,8.23-5.838c1.574-1.48,3.383-2.754,4.862-4.328a34.486,34.486,0,0,0,4.438-5.681,18.673,18.673,0,0,1,5.949-6.2,17.054,17.054,0,0,1,4.359,1.432c2.864.944,5.712,1.888,8.56,2.864h.016a53.721,53.721,0,0,0,10.874,2.612c1.668.189,3.352.268,5.036.378.361.016.723-.126,1.085-.079a41.03,41.03,0,0,0,10.748-.85,55.614,55.614,0,0,0,17.122-5.57l1.227-.771a44.634,44.634,0,0,0,9.5-10.827,6.327,6.327,0,0,0,.85-3.462,17.138,17.138,0,0,0-1.322-7.979,2.637,2.637,0,0,1,3.006,1.118,10.222,10.222,0,0,1,2.187,9.473,14.037,14.037,0,0,1-2.659,5.461c-1.495,1.731-2.88,3.541-4.312,5.319l-.661.865v-.016a17.176,17.176,0,0,1-9.82,8.482c-2.533,1.118-5.177,1.968-7.773,2.927a4.807,4.807,0,0,0-1.669.646,16.216,16.216,0,0,1-7.6,3.084,24.812,24.812,0,0,1-6.09.614,31.9,31.9,0,0,1-8.655-.425l-.362-.032c-4.784-.283-6.72.74-8.026,5.319h.016a13.794,13.794,0,0,1-4.548,6.736c-.9.786-1.715,1.7-2.612,2.5v-.016a22.972,22.972,0,0,1-2.738,2.345,61.794,61.794,0,0,1-9.568,5.791,55.138,55.138,0,0,1-13.817,4.988,38.109,38.109,0,0,0-7.3,2.014,59.778,59.778,0,0,1-14.21,2.471,27.545,27.545,0,0,1-6.122-.409c-3.1-.393-6.184-.96-9.3-1.385a31.617,31.617,0,0,1-8.907-2.9c-1.967-.9-3.981-1.7-5.964-2.581-2.754-1.228-5.523-2.392-8.214-3.745h-.016a25.115,25.115,0,0,1-3.541-2.487c-3.855-2.9-7.679-5.807-11.55-8.686a16.183,16.183,0,0,0-2.015-1.039c-1.7,1.6-3.273,3.258-5,4.721a16.815,16.815,0,0,1-7.852,4.186c-2.959.52-5.807,1.432-8.828,1.81v-.016a59.621,59.621,0,0,1-20.458-1.243,9.778,9.778,0,0,1-4.312-1.747,5.861,5.861,0,0,0-2.6-1.243,7.236,7.236,0,0,1-4.626-2.549,3.811,3.811,0,0,0-1.527-.929,29.391,29.391,0,0,1-9.914-7.7l-2.266-2.329a30.769,30.769,0,0,1-5.791-7.349,10.713,10.713,0,0,0-1.416-2.108,43.5,43.5,0,0,1-7.491-15.532,24.038,24.038,0,0,1-.613-5.713,41.825,41.825,0,0,1,1.573-13.958c.409-1.511.771-3.037,1.243-4.532a3.331,3.331,0,0,0-.755-3.336,22.247,22.247,0,0,1-2.5-3.509,98.723,98.723,0,0,0-6-9.883,25.24,25.24,0,0,1-3.855-16.208,86.429,86.429,0,0,1,3.965-19.45,26.627,26.627,0,0,1,2.6-5.13,36.077,36.077,0,0,1,4.438-7,14.07,14.07,0,0,1,1.479-1.59,100.258,100.258,0,0,1,8.026-6.152,43.634,43.634,0,0,1,15.862-6.625c1.542-.268,3.053-.63,4.753-.992h.015a20.647,20.647,0,0,0,.551-2.407,48.179,48.179,0,0,1,5.272-17.185l.613-1.306a12.841,12.841,0,0,1,5.713-6.766c.6-.394,1.4-.677,1.747-1.228a12.045,12.045,0,0,1,5.854-3.965,41.7,41.7,0,0,1,14.509-4.2,11.563,11.563,0,0,0,2.769-.771,14.312,14.312,0,0,1,7.444-.819l.708.111h.016a28.4,28.4,0,0,1,8.246.346,3.335,3.335,0,0,0,3.336-1.684c.566-.913,1.259-1.763,1.888-2.644a31.063,31.063,0,0,1,7.868-6.814c2.44-1.778,4.989-3.383,7.538-4.988a47.3,47.3,0,0,1,21.355-7.255,111.2,111.2,0,0,1,14.1-.488,33.948,33.948,0,0,1,10.228,2.015,79.922,79.922,0,0,1,14.431,6.64l1.243.74c4.3,3.493,8.718,6.861,12.841,10.559a29.5,29.5,0,0,1,9.206,18.019,35.2,35.2,0,0,1-.095,6.31,12.047,12.047,0,0,0,1.967.315c2.172,0,4.344-.079,6.5-.142h.015a80.381,80.381,0,0,1,11.173.645,93.529,93.529,0,0,1,19.325,4.422,21.5,21.5,0,0,1,7.3,3.871,7.947,7.947,0,0,0,1.448,1.07,23.647,23.647,0,0,1,8.167,7.507c1.291,1.731,2.77,3.336,4.123,5.036a11.509,11.509,0,0,1,1.385,2.092c1.416,2.927,2.832,5.854,4.123,8.829v.015a20.691,20.691,0,0,1,1.652,8.435,21.182,21.182,0,0,1-2.612,10.386c-1.1,1.936-.913,2.8.613,4.517v-.016a25.506,25.506,0,0,0,6.09,5.067,7.858,7.858,0,0,1,2.975,3.069,62.018,62.018,0,0,1,5.366,10.527,13.34,13.34,0,0,1-.63,11.787,20.619,20.619,0,0,0-2.093,3.777,30.306,30.306,0,0,1-7.679,9.033,11.442,11.442,0,0,1-7.459,2.281,7.863,7.863,0,0,0-5.178,1.118l-.661.236c-2.47-.756-4.973.676-7.428-.158l-.708-.125a14.753,14.753,0,0,1-7.018-1.259c-2.03-.724-4.186-1.07-6.279-1.606l-1.936-.629a1.2,1.2,0,0,1-.078-.96,1.125,1.125,0,0,1,.708-.629c2.549-1.07,5.13-2.078,7.663-3.163a38.021,38.021,0,0,0,4.58-2.156,29.1,29.1,0,0,0,13.6-19.183,18.623,18.623,0,0,0,.016-5.036c-.032-.708-.378-1.416-.41-2.124a14.417,14.417,0,0,0-4.17-8.23,3.5,3.5,0,0,0-1.857-.976,21.834,21.834,0,0,0-2.864-.409c-.661-.929-.724-2.361-2.25-2.565l.016.015a1.426,1.426,0,0,1-.976-.9c-.095-1.589-1.228-2.549-2-3.761a15.7,15.7,0,0,1-1.117-3.005,12.555,12.555,0,0,1,.63-10.8,21.5,21.5,0,0,0,2.03-8.388,15.518,15.518,0,0,0-4.926-13.061,23.377,23.377,0,0,0-3.431-2.644c-1.7-1.117-3.477-2.14-5.256-3.147a6.924,6.924,0,0,0-2-.818,50.824,50.824,0,0,0-13.943-1.889,6.05,6.05,0,0,1-1.07.016,59.2,59.2,0,0,0-21.087,1.841l-1.4.173c-1.731-1.117-3.258-.047-4.847.3-2.581.567-5.177,1.086-7.742,1.7-1.747.425-3.431,1.07-5.178,1.495-1.888.456-2.471-.016-2.628-1.81l.016-.362a46.064,46.064,0,0,1,.8-17.908,17.752,17.752,0,0,0-4.2-15.453l-1.291-1.243v-.016a23.255,23.255,0,0,0-13.9-5.445c-3.493-.047-7-.2-10.465.094v-.015q-6.279.59-12.495,1.794a22.875,22.875,0,0,0-6.121,2.093,56.865,56.865,0,0,0-7.853,3.572,22.165,22.165,0,0,0-6.216,6.908,26.58,26.58,0,0,0-2.3,4.878,7.153,7.153,0,0,0-.047,2.833c.11,1.085.5,2.234-.2,3.163-1.212,1.589-.677,2.848.409,4.2.724.9.645.96-.078,2.99Z"
                                                                             transform="translate(-2261.49 -1532.594)"
                                                                             fill="#fff"/></svg>
                                </span>
                    </div>
                    <span className="bgCover d-block imgBgWarn rounded"
                          style={{backgroundImage: 'url(/images/imgdev4.png)'}}></span>
                </article>
            </div>
            <Modal
                show={showModal}
                className="editInfoModal addChipModal generalPopupStyles"
                centered
                onHide={() => setShowModal(false)}
            >
                <Modal.Body>
                    <h4 className="h4 text-center mb-8">Guest Checkout</h4>
                    <form onSubmit={handleGuestCheckout}>
                        <div className="row">
                            <div className="col-12 col-sm-6">
                                <div className="form-group">
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="First name..."
                                        value={guestData.first_name}
                                        onChange={(e) => setGuestData({...guestData, first_name: e.target.value})}
                                    />
                                    {modalErrors.first_name && (
                                        <small className="support-error">
                                            {modalErrors.first_name}
                                        </small>
                                    )}
                                </div>
                            </div>
                            <div className="col-12 col-sm-6">
                                <div className="form-group">
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Last name..."
                                        value={guestData.last_name}
                                        onChange={(e) => setGuestData({...guestData, last_name: e.target.value})}
                                    />
                                    {modalErrors.last_name && (
                                        <small className="support-error">
                                            {modalErrors.last_name}
                                        </small>
                                    )}
                                </div>
                            </div>
                            <div className="col-12 col-sm-6">
                                <div className="form-group">
                                    <input
                                        className="form-control"
                                        type="email"
                                        placeholder="Email..."
                                        value={guestData.email}
                                        onChange={(e) => setGuestData({...guestData, email: e.target.value})}
                                    />
                                    {modalErrors.email && (
                                        <small className="support-error">
                                            {modalErrors.email}
                                        </small>
                                    )}
                                </div>
                            </div>
                            <div className="col-12 text-center mt-3">
                                <div className="um-formBtnWrap">
                                    <button type="submit" className="btn btnFormWidth btnFormStyle small btn-warning">
                                        Checkout
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );

};

export default ViewAdvert;
